import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {DialogActions, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Tooltip} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import SnackbarMessage from "../Custom/SnackbarMessage";
import {connect} from "react-redux";
import {clear_cluster_error} from "../../actions/clusters";
import google_translatable_languages from "../../utilities/google_translatable_languages.json";
import google_listenable_languages from "../../utilities/google_listenable_languages.json";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CampaignIcon from "@mui/icons-material/Campaign";

class ClusterDialog extends Component {

    constructor(props) {
        super(props);
        this.state = props.cluster ?
            {
                ...props.cluster,
                title: props.cluster.title ? props.cluster.title : "",
                description: props.cluster.description ? props.cluster.description : "",
                col_1_name: props.cluster.col_1_name ? props.cluster.col_1_name : "",
                col_2_name: props.cluster.col_2_name ? props.cluster.col_2_name : "",
                col_3_name: props.cluster.col_3_name ? props.cluster.col_3_name : "",
                col_1_language: props.cluster.col_1_language ? props.cluster.col_1_language : "-",
                col_2_language: props.cluster.col_2_language ? props.cluster.col_2_language : "-",
                col_3_language: props.cluster.col_3_language ? props.cluster.col_3_language : "-",
                titleTouched: true,
                descriptionTouched: true,
                col_1_nameTouched: true,
                col_2_nameTouched: true,
                col_3_nameTouched: true,
                col_1_languageTouched: true,
                col_2_languageTouched: true,
                col_3_languageTouched: true
            } : {
                title: "",
                description: "",
                col_1_name: "",
                col_2_name: "",
                col_3_name: "",
                col_1_language: "-",
                col_2_language: "-",
                col_3_language: "-",
                titleTouched: false,
                descriptionTouched: false,
                col_1_nameTouched: false,
                col_2_nameTouched: false,
                col_3_nameTouched: false,
                col_1_languageTouched: false,
                col_2_languageTouched: false,
                col_3_languageTouched: false
            };
    }

    onChange = e => this.setState({
        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    isTitleInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.titleTouched) return false;
        if (this.state.title.trim().length < 3) return "Title must be at least 3 characters long.";
        return false;
    }

    isCol1Invalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.col_1_nameTouched) return false;
        if (this.state.col_1_name.trim().length < 2) return "Column must be at least 2 characters long.";
        return false;
    }

    isCol2Invalid(ignoreTouch = false) {
        //if (!ignoreTouch && !this.state.col_2_nameTouched) return false;
        //if (this.state.col_2_name.trim().length < 2) return "Column must be at least 2 characters long.";
        return false;
    }

    isCol3Invalid(ignoreTouch = false) {
        //if (!ignoreTouch && !this.state.col_3_nameTouched) return false;
        //if (this.state.col_3_name.trim().length < 2) return "Column must be at least 2 characters long.";
        return false;
    }

    isDescriptionInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.descriptionTouched) return false;
        //if(this.state.description.length < 3) return "Title must be at least 3 characters long.";
        return false;
    }

    isValid() {
        return !this.isTitleInvalid(true) && !this.isDescriptionInvalid(true) && !this.isCol1Invalid(true) && !this.isCol2Invalid(true) && !this.isCol3Invalid(true);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.cluster) {
            const old_cluster = prevProps.clusters.find((cluster) => cluster.id === this.props.cluster.id);
            const cluster = this.props.clusters.find((cluster) => cluster.id === this.props.cluster.id);
            if (cluster && old_cluster) {
                if (old_cluster.updated_at !== cluster.updated_at) {
                    this.props.handleClose();
                }
            }
        }
    }

    render() {
        const no_translation = <em>No selection</em>;
        //console.log(this.state);
        const languages_tooltip = <Typography>Select from 100+ Languages</Typography>;
        return (<Dialog open={this.props.open} onClose={this.props.handleClose}>
                <DialogTitle>{this.props.cluster ? "Modify cluster" : "Create cluster"}</DialogTitle>
                <DialogContent>
                    {this.props.error && <SnackbarMessage onClose={this.props.clear_cluster_error} type="error"
                                                          message={this.props.error.message} autoHideDuration={null}
                                                          anchorOrigin={false}
                                                          style={{marginBottom: 30}}/>}
                    <TextField
                        variant="standard"
                        margin="dense"
                        name="title"
                        label="Title"
                        type="text"
                        value={this.state.title}
                        fullWidth
                        onChange={this.onChange}
                        helperText={this.isTitleInvalid()}
                        error={Boolean(this.isTitleInvalid())}
                        required
                    />
                    <TextField
                        variant="standard"
                        margin="dense"
                        name="description"
                        label="Description"
                        type="text"
                        value={this.state.description}
                        fullWidth
                        onChange={this.onChange}
                        multiline
                        helperText={this.isDescriptionInvalid()}
                        error={Boolean(this.isDescriptionInvalid())}
                    />
                    <Grid container spacing={0}>
                        <Grid item xs={8}>
                            <TextField
                                variant="standard"
                                margin="dense"
                                name="col_1_name"
                                label="Column 1 name"
                                type="text"
                                value={this.state.col_1_name}
                                fullWidth
                                onChange={this.onChange}
                                helperText={this.isCol1Invalid()}
                                error={Boolean(this.isCol1Invalid())}
                                required
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth style={{marginTop: 5}} variant="standard">
                                <InputLabel variant="standard" htmlFor="col-1-language">
                                    Column 1 language
                                </InputLabel>

                                <Tooltip title={languages_tooltip} placement="left" interactive>
                                    <Select
                                        labelId="col-1-language"
                                        id="col-1-language"
                                        name="col_1_language"
                                        value={this.state.col_1_language}
                                        onChange={this.onChange}
                                    >
                                        <MenuItem value="-">
                                            {no_translation}
                                        </MenuItem>
                                        {Object.entries(google_translatable_languages).map(l => <MenuItem
                                            key={"c1-" + l[0]}
                                            value={l[0]}>{l[1]}
                                            {l[0] in google_listenable_languages && <CampaignIcon
                                                fontSize="26px" style={{marginLeft: 5}}/>}</MenuItem>)}
                                    </Select>
                                </Tooltip>
                            </FormControl>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                variant="standard"
                                margin="dense"
                                name="col_2_name"
                                label="Column 2 name"
                                type="text"
                                value={this.state.col_2_name}
                                fullWidth
                                onChange={this.onChange}
                                helperText={this.isCol2Invalid()}
                                error={Boolean(this.isCol2Invalid())}
                                //required
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth style={{marginTop: 5}} variant="standard">
                                <InputLabel variant="standard" htmlFor="col-2-language">
                                    Column 2 language
                                </InputLabel>
                                <Tooltip title={languages_tooltip} placement="left" interactive>
                                    <Select
                                        labelId="col-2-language"
                                        id="col-2-language"
                                        name="col_2_language"
                                        value={this.state.col_2_language}
                                        onChange={this.onChange}
                                    >
                                        <MenuItem value="-">
                                            {no_translation}
                                        </MenuItem>
                                        {Object.entries(google_translatable_languages).map(l => <MenuItem
                                            key={"c2-" + l[0]}
                                            value={l[0]}>{l[1]}
                                            {l[0] in google_listenable_languages && <CampaignIcon
                                                fontSize="26px" style={{marginLeft: 5}}/>}</MenuItem>)}
                                    </Select>
                                </Tooltip>
                            </FormControl>
                        </Grid>

                        <Grid item xs={8}>
                            <TextField
                                variant="standard"
                                margin="dense"
                                name="col_3_name"
                                label="Column 3 name"
                                type="text"
                                value={this.state.col_3_name}
                                fullWidth
                                onChange={this.onChange}
                                helperText={this.isCol3Invalid()}
                                error={Boolean(this.isCol3Invalid())}
                                //required
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth style={{marginTop: 5}} variant="standard">
                                <InputLabel variant="standard" htmlFor="col-3-language">
                                    Column 3 language
                                </InputLabel>
                                <Tooltip title={languages_tooltip} placement="left">
                                    <Select
                                        labelId="col-3-language"
                                        id="col-3-language"
                                        name="col_3_language"
                                        value={this.state.col_3_language}
                                        onChange={this.onChange}
                                    >
                                        <MenuItem value="-">
                                            {no_translation}
                                        </MenuItem>
                                        {Object.entries(google_translatable_languages).map(l => <MenuItem
                                            key={"c3-" + l[0]}
                                            value={l[0]}>
                                            {l[1]}
                                            {l[0] in google_listenable_languages && <CampaignIcon
                                                fontSize="26px" style={{marginLeft: 5}}/>}
                                        </MenuItem>)}
                                    </Select>
                                </Tooltip>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button disabled={!this.isValid()} onClick={() => this.props.handleSave(this.state)}
                            color="primary">
                        {this.props.cluster ? "Save" : "Create"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = state => ({
    error: state.clusters.error,
    clusters: state.clusters.clusters,
});
export default connect(
    mapStateToProps,
    {clear_cluster_error}
)(ClusterDialog);
